<template>
    <div>
        <div class="py-3" style="">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="d-flex justify-content-center">Pending Payment</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-5">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <b-spinner class="center-spinner" v-if="!loaded" variant="primary" label="Spinning"></b-spinner>
                        <div v-if="loaded">
                            <b-table striped
                                     hover
                                     :fields="['Selected','SubmitterName','SubmittedDate','Type','ReportName','Project','Approvals','Status','ReimbursementTotal']"
                                     :items="response"
                                     show-empty="true" empty-text='There are no records to show'>
                                <template v-slot:head(Selected)="data">
                                    <b-button size="sm" @click="selectAll()" class="mr-2">
                                        Select All
                                    </b-button>
                                </template>
                                <template v-slot:cell(Selected)="data">
                                    <b-form-checkbox v-model="data.item.Selected">
                                    </b-form-checkbox>
                                    {{data.item.Selected}}
                                </template>
                                <template v-slot:cell(ReportName)="data">
                                    <span v-html="data.value"></span>
                                </template>
                                <template v-slot:cell(SubmittedDate)="data">
                                    {{data.value | formatDate}}
                                </template>
                                <template v-slot:cell(ReimbursementTotal)="data">
                                    {{data.value | currency}}
                                </template>
                                <!--<template v-slot:cell(PaidDate)="row">
                                    <datepicker :typeable="false" :format="'MMMM dd yyyy'" input-class="form-control" :use-utc=false v-model="row.item.PaidDate"></datepicker>
                                </template>
                                <template v-slot:cell(Pay)="row">
                                    <b-button size="sm" @click="pay(row.item.Pay,row.item.PaidDate)" class="mr-2">
                                        pay
                                    </b-button>
                                </template>-->
                            </b-table>

                            <div class="form-group">
                                <datepicker placeholder="Enter pay date" :typeable="false" :format="'MMMM dd yyyy'" input-class="form-control w-25" style="margin-bottom:10px;" :use-utc=false v-model="paidDate"></datepicker>
                                <b-button size="sm" @click="paySelected()" class="mr-2">
                                    Pay
                                </b-button>
                            </div>
                            <div class="form-group">
                                <b-form-select class="w-50 form-control mb-1" v-model="selectedStatusTypeId">
                                    <option :value="null" disabled>Choose a status</option>
                                    <option :value="6">Send Back to User (As Admin)</option>
                                    <option :value="2">Pending PI Approval</option>
                                    <option :value="3">Pending Admin 1 Approval</option>
                                    <option :value="4">Pending Admin 2 Approval</option>
                                </b-form-select>
                                <div>
                                    <b-button size="sm" @click="setStatusSelected()" class="mr-2">
                                        Update Status
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ReportService from '@/services/ReportService'
    import ApprovalService from '@/services/ApprovalService'
    import Datepicker from 'vuejs-datepicker';

    export default {
        components: {
            Datepicker
        },
        async created() {
            this.response = await ReportService.getPendingPayments();
            this.loaded = true;
        },
        data() {
            return {
                response: null,
                isSelectAll: false,
                paidDate: null,
                loaded: false,
                selectedStatusTypeId: null
            }
        },
        methods: {
            selectAll() {
                if (this.isSelectAll) {
                    this.response.forEach(element => element.Selected = false);
                    this.isSelectAll = false;
                }
                else {
                    this.response.forEach(element => element.Selected = true);
                    this.isSelectAll = true;
                }
            },
            async paySelected() {
                if (this.paidDate) {
                    for await (const item of this.response) {
                        if (item.Selected) {
                            try {
                                let payDate = this.paidDate.toISOString().split('T')[0]
                                await ApprovalService.pay(item.Pay, payDate);
                                this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "Marked as paid" });
                            } catch (e) {
                                this.$notify({ group: 'errors', type: 'error', title: 'Error', text: e });
                            }
                        }
                    }
                    this.response = await ReportService.getPendingPayments();
                }
                else {
                    this.$notify({ group: 'errors', type: 'error', title: 'Error', text: 'Pay date is required.' });
                }
            },
            async pay(id, payDate) {
                payDate = payDate.toISOString().split('T')[0]
                try {
                    await ApprovalService.pay(id, payDate);
                    this.response = await ReportService.getPendingPayments();
                    this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "Marked as paid" });
                } catch (e) {
                    this.$notify({ group: 'errors', type: 'error', title: 'Error', text: e });
                }
            },
            async setStatusSelected() {
                if (this.selectedStatusTypeId) {
                    for await (const item of this.response) {
                        if (item.Selected) {
                            await this.setStatus(item.Pay, this.selectedStatusTypeId)
                        }
                    }

                    this.response = await ReportService.getPendingPayments();
                    this.selectedStatusTypeId = null;
                }
                else {
                    this.$notify({ group: 'errors', type: 'error', title: 'Error', text: 'Status is required.' });
                }
            },
            async setStatus(id, statusTypeId) {
                try {
                    await ApprovalService.setPendingPaymentStatus(id, statusTypeId);
                    this.response = await ReportService.getPendingPayments();
                    this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "Status updated" });
                } catch (e) {
                    this.$notify({ group: 'errors', type: 'error', title: 'Error', text: e });
                }
            }
        }
    }
</script>